// extracted by mini-css-extract-plugin
export default {"paintingsDescriptionSection":"PaintingsDescriptionSection_paintingsDescriptionSection__JkOTQ","description":"PaintingsDescriptionSection_description__GHvCh"};